import { render } from "./Branch.vue?vue&type=template&id=555e920f&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-555e920f"

export default script